<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Death_In_the_12th_House-1.html" xml:lang="en-US">
<div class="calibre1">
<p class="ct" id="toc_marker-2"><span class="char-style-override">Death in the 12th House</span></p>
<p class="book-author" xml:lang="en-GB">Where Neptune Rules</p>
<p class="book-subtitle" xml:lang="en-GB"><span class="char-style-override1">A Starlight Detective Agency Mystery</span></p>
<p class="book-author1" xml:lang="en-GB">Mitchell Scott Lewis</p>
<p class="body-center"><a class="calibre2" href="http://www.mitchastro.com/home.html" target="_blank"><span class="hyperlink" xml:lang="en-US">www.mitchastro.com/home.html</span></a></p>
<p class="book-publisher" xml:lang="en-GB">Poisoned Pen Press</p>
<p class="body-center"><img alt="PPPlogo.jpg" class="image1" src="OEBPS/images/PPPlogo_fmt.png"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Death_In_the_12th_House-1.vue?1b882f11